export { default } from 'cccisd-game-emotionexplorer';
